module.exports = __webpack_public_path__ + "img/glass-group_mobile.caaf637a.png";